import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const ClientList = React.lazy(() => import("./ClientList"));
const CallLogsDetails = React.lazy(() => import("./CallLogsDetails"));
const ApprovalList = React.lazy(() => import("./ApprovalRequest/ApprovalList"));
const RequestLogs = React.lazy(() => import("./RequestLogs"));
export const CRMConfig = [
    {
        permittedRole: [
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            // RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.FINANCE_MANAGER,
            // RoutePermittedRole.HR_MANAGER,
        ],
        path: "/crm/client-list",
        element: <ClientList />,
    },
    {
        permittedRole: [
            // RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            // RoutePermittedRole.DOCTOR,
            // RoutePermittedRole.FINANCE_MANAGER,
            // RoutePermittedRole.HR_MANAGER,
        ],
        path: "/client-details/:type/:id",
        element: <CallLogsDetails />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.FINANCE_MANAGER,
        ],
        path: "/crm/approval",
        element: <ApprovalList />,
    },
    {
        permittedRole: [
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.FINANCE_MANAGER,
        ],
        path: "/crm/logs",
        element: <RequestLogs />,
    },
];
